import * as pdfjsLib from 'pdfjs-dist'
export const pdfjs = { getDocument: pdfjsLib.getDocument, GlobalWorkerOptions: pdfjsLib.GlobalWorkerOptions, workerSrc: '/pdf.worker.min.mjs' }
